import {
  MerchantServiceApiFactory,
  type MerchantServiceApiMerchantServiceUpdateRequest,
  type ModelMerchantResponse,
} from '@layup/api-sdk';
import { createLayupClient } from './layupApi';

const merchantServiceClient = () => {
  const client = createLayupClient();
  return MerchantServiceApiFactory(undefined, undefined, client);
};

export async function getMerchant(id: string): Promise<ModelMerchantResponse> {
  const client = createLayupClient(false);
  const response = await client.get(`/v1/merchants/${id}`);
  return response.data as ModelMerchantResponse;
}

export const saveMerchant = async (
  params: MerchantServiceApiMerchantServiceUpdateRequest,
): Promise<ModelMerchantResponse> => {
  const response = await merchantServiceClient().merchantServiceUpdate(params);
  return response.data;
};
